import { Server } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import {
  FleetMachineSummary,
  FLEET_MACHINE_PROVIDER_LABELS,
  FLEET_MACHINE_ENVIRONMENT_LABELS,
  FLEET_MACHINE_CONTROL_MODE_LABELS,
} from '@/frontend/types/fleetMachine'

interface Props {
  fleetMachine: FleetMachineSummary | null
}

export default function WorkerFleetMachineCard({ fleetMachine }: Props) {
  return (
    <section className="bg-card border border-border rounded-xl p-4">
      <div className="flex items-center gap-2 mb-3">
        <Server className="h-4 w-4 text-muted-foreground" />
        <h3 className="text-[14px] font-semibold text-foreground">Máquina</h3>
      </div>
      {fleetMachine ? (
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-medium text-foreground">{fleetMachine.name}</span>
          <span className="text-xs text-muted-foreground font-mono">({fleetMachine.slug})</span>
          <Badge variant="secondary">{FLEET_MACHINE_PROVIDER_LABELS[fleetMachine.provider]}</Badge>
          <Badge variant="secondary">{FLEET_MACHINE_ENVIRONMENT_LABELS[fleetMachine.environment]}</Badge>
          <Badge variant="secondary">{FLEET_MACHINE_CONTROL_MODE_LABELS[fleetMachine.control_mode]}</Badge>
          {!fleetMachine.enabled && <Badge variant="warning">Desabilitada</Badge>}
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">Não atribuída.</p>
      )}
    </section>
  )
}
